import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=23ac497c&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=23ac497c&prod&lang=scss"
import style1 from "./Layout.vue?vue&type=style&index=1&id=23ac497c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac497c",
  null
  
)

export default component.exports